import { useSelector, useDispatch } from 'react-redux';
import { login, logout } from '../../store/authSlice';
import './header.css';

export const Topbar = () => {
  const { isAuth, user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const handleLogin = () => {
    dispatch(login({ id: 1, name: 'Fulanito' }));
  };

  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <div className='header-top'>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-7 col-md-5 d-none d-lg-block d-md-block'>
            <i className='fa fa-phone'></i> <span>(662) 1080630 </span>
          </div>
          <div className='col-lg-5 col-md-7 col-12'>
            {/*<div className="header-top-right">
              {!isAuth ? (
                <div className="content pointer" onClick={handleLogin}>
                  <a>
                    <i className="fa fa-sign-out" aria-hidden="true"></i>
                    Iniciar sesión
                  </a>
                </div>
              ) : (
                <>
                  <div className="content">
                    <a>
                      <i className="zmdi zmdi-account"></i> Mi perfil
                      {user.name && ` (${user.name})`}
                    </a>
                  </div>

                  <div className="content pointer" onClick={handleLogout}>
                    <a>
                      <i className="fa fa-sign-out" aria-hidden="true"></i>
                      Salir
                    </a>
                  </div>
                </>
              )}
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};
